export default __webpack_public_path__ + "static/media/textIcon2.ae486807.svg";